import { useWhatsNewStore } from '@/components/WhatsNew/WhatsNewState'
import { Button } from 'devextreme-react'
import { BounceLoader } from 'react-spinners'

export const WhatsNewButton = () => {
  const { hasRead, open } = useWhatsNewStore()

  return (
    <div className="whats-new-button">
      <Button
        className="theme-button"
        stylingMode="text"
        icon="info"
        onClick={open}
        render={() => (
          <BounceLoader size={20} color={hasRead() ? 'gray' : 'orange'} speedMultiplier={hasRead() ? 0.01 : 1} />
        )}
      />
    </div>
  )
}
